import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { RoomCard } from '../components/RoomCard';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Rooms = () => {
  const { t } = useLanguage();
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRooms = async () => {
      try {
        const response = await axios.get(`${API}/rooms`);
        setRooms(response.data);
      } catch (error) {
        console.error('Error fetching rooms:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchRooms();
  }, []);

  return (
    <div className="min-h-screen bg-[#F9F8F6]" data-testid="rooms-page">
      {/* Hero */}
      <section className="relative h-[50vh] min-h-[400px] flex items-center justify-center">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1709187516056-d4929b67e89f?crop=entropy&cs=srgb&fm=jpg&q=85"
            alt="Rooms"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-[#0F1F3C]/50" />
        </div>
        <div className="relative z-10 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <p className="text-[#D4AF37] text-xs uppercase tracking-[0.3em] font-sans font-medium mb-4">
              Accommodations
            </p>
            <h1 className="font-serif text-5xl lg:text-6xl text-white">
              {t('rooms.title')}
            </h1>
          </motion.div>
        </div>
      </section>

      {/* Rooms Grid */}
      <section className="py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
            className="text-center text-[#64748B] font-sans max-w-2xl mx-auto mb-16"
          >
            {t('rooms.subtitle')}
          </motion.p>

          {loading ? (
            <div className="grid md:grid-cols-2 gap-12">
              {[1, 2, 3, 4].map((i) => (
                <div key={i} className="animate-pulse">
                  <div className="bg-gray-200 h-[400px] mb-6" />
                  <div className="bg-gray-200 h-8 w-2/3 mb-4" />
                  <div className="bg-gray-200 h-4 w-full mb-2" />
                  <div className="bg-gray-200 h-4 w-3/4" />
                </div>
              ))}
            </div>
          ) : (
            <div className="grid md:grid-cols-2 gap-12">
              {rooms.map((room, index) => (
                <RoomCard key={room.id} room={room} index={index} />
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};
